import { Flex } from '@fabric-app/ui/components/Flex';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import styled from 'styled-components';

export const CenteringContainer = styled(Flex).attrs({
  direction: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})`
  width: 100%;
  max-width: 680px;
  margin: auto;
  gap: 60px;
  text-align: center;
  flex-grow: 1;
  padding: 3rem 1rem 8rem 1rem;

  ${mediaMobile} {
    justify-content: flex-start;
    padding-top: 2.5rem;
  }
`;

export const AuthPageWrapper = styled(Flex).attrs({
  direction: 'column',
  justifyContent: 'center',
})`
  max-width: 100vw;
  min-height: 100dvh;
  padding-top: env(safe-area-inset-top);
  padding-bottom: calc(env(safe-area-inset-bottom) + var(--keyboard-height, 0px));
  color: var(--fabric-color-text-primary);

  ${mediaMobile} {
    justify-content: flex-start;
  }
`;
